import { setLoading, showSnackbar, toggleModal } from 'reducers/ui';
import API from 'services/api';
import get from 'lodash/get';
import { errorHandler } from 'utils/errorMessages';
import {
  pendingCompanyActions,
  pendingCompanyFilterActions,
  pendingCompanyPageActions,
} from 'containers/Pages/Region/PendingCompany';
import { call, put, takeLatest } from 'redux-saga/effects';
import { PAGE_URLS } from 'utils/constants';
export function* createPendingCompanySaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { pendingCompany } = payload;
    const { status } = yield call(API.createPendingCompany, pendingCompany);
    if (status === 200) {
      yield put(toggleModal(PAGE_URLS.PENDING_COMPANY.name));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchPendingCompaniesListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const { data } = yield call(API.fetchPendingSecurityCompanies, {
      ...filters,
      from,
    });
    if (data.data != null) {
      const totalEntries = get(data, 'meta.total');
      yield put(
        pendingCompanyActions.setGridList({ list: data.data, totalEntries }),
      );
    }
    yield put(pendingCompanyFilterActions.setFilterKey(false));
    yield put(pendingCompanyActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchPendingCompanyDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.fetchPendingCompanyDetail, id);
    if (data.data) {
      yield put(
        pendingCompanyActions.setGridRowDetails({
          details: data.data,
        }),
      );
    }
  } catch (error) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* rejectPendingCompanySaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.rejectPendingCompany, id);
    if (data.data) {
      yield put(
        showSnackbar({ typeOfSnackbar: 'warning', message: 'Rejected' }),
      );
      yield put(
        pendingCompanyActions.setGridRowDetails({
          details: data.data,
        }),
      );
      /**
       *TODO call the list function again on success and close the
       */
    }
  } catch (error) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* acceptPendingCompanySaga({ payload }) {
  try {
    yield put(setLoading(true));
    const {
      id,
      region,
      subscriptions,
      trialLength,
      trialAutoExtendLength,
    } = payload;
    const { status } = yield call(API.approvePendingCompany, {
      id,
      region,
      subscriptions,
      trialLength,
      trialAutoExtendLength,
    });
    if (status === 200) {
      yield put(toggleModal(PAGE_URLS.PENDING_COMPANY.name));
      yield call(fetchPendingCompanyDetailsSaga, { payload: { id } });
    }
  } catch (error) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchSubscriptionsListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.fetchAllAvailablePlans, id);
    if (data.data) {
      yield put(
        showSnackbar({ typeOfSnackbar: 'success', message: 'Plans retrieved' }),
      );
    }
  } catch (error) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* pendingCompanySagas() {
  yield takeLatest(
    pendingCompanyActions.fetchGridList,
    fetchPendingCompaniesListSaga,
  );
  yield takeLatest(
    pendingCompanyActions.fetchGridRowDetails,
    fetchPendingCompanyDetailsSaga,
  );
  yield takeLatest(
    pendingCompanyPageActions.rejectPendingCompany,
    rejectPendingCompanySaga,
  );
  yield takeLatest(
    pendingCompanyPageActions.acceptPendingCompany,
    acceptPendingCompanySaga,
  );
  yield takeLatest(
    pendingCompanyPageActions.fetchSubscriptions,
    fetchSubscriptionsListSaga,
  );
  yield takeLatest(
    pendingCompanyActions.createRowEntry,
    createPendingCompanySaga,
  );
}
